<template>
  <div class="card-item min-height-100">
    <section>
      <div class="mb-4">
        <p class="is-size-6 payment-description">Abona saldo para seguro de cesantía, MINVU e Inmobiliarias:</p>
      </div>
      <div class="mb-4">
        <section>
          <b-field>
            <b-upload
              id="payment-resume-fileUpload"
              v-model="file"
              @change="uploadWalletsEntriesFile">
              <a class="button is-primary is-fullwidth">
                <b-icon icon="upload" />
                <span>{{ file.name || $t('transactions.uploadInstructions') }}</span>
              </a>
            </b-upload>
          </b-field>
          <p v-if="!file.name" class="is-size-7 has-text-grey">Ningún archivo seleccionado</p>
          <p v-if="file.name && !isFileExtensionValid" class="is-size-7 has-text-danger">{{ `El archivo que subiste tiene extensión ${fileType}` }}</p>
        </section>
      </div>
      <!-- <div class="upload-buttongroup field file has-addons">
        <label class="upload control file-label">
          <input
            id="payment-resume-fileUpload"
            type="file"
            class="file-input"
            @change="uploadWalletsEntriesFile">
          <span class="file-cta">
            <span class="file-icon"><i class="fas fa-upload" /></span>
            <span class="file-label">{{ $t('transactions.upload') }}</span>
          </span>
          <span v-if="file" class="file-name">
            {{ file.name }}
          </span>
        </label>
      </div> -->
      <!-- <p v-if="!isFileExtensionValid" class="help is-danger">
        {{ $t('transactions.uploadInstructions') }}
      </p> -->
      <div class="control has-text-right">
        <button
          id="payment-resume-process"
          :disabled="isProcessing || !isFileExtensionValid"
          class="button is-button-primary"
          @click="processPaymentFile">
          <span v-if="isProcessing">
            <i class="fas fa-spinner fa-spin" />
          </span>
          <span v-if="!isProcessing">{{ $t('transactions.upload') }}</span>
        </button>
      </div>
      <div id="payment-resume-result" class="control">
        <p v-if="resultMessage" v-html="resultMessage" />
      </div>
    </section>
  </div>
</template>

<script>
import { CreditToWalletReader } from '@/application/services/readers/credit-to-wallet-reader';
import {
  createWalletEntryForDifferentPaymentSources
} from '@/application/services/api-clients/transactions';
import notification from '@/ui/mixins/notification';

export default {
  name: 'WalletsEntries',
  mixins: [notification],
  data() {
    return {
      isModalVisible: false,
      file: {},
      isProcessing: false,
      bankAccount: {},
      resultMessage: '',
      increase: true
    };
  },
  computed: {
    fileType() {
      if (this.file !== null) {
        return this.file.type;
      }
      return null;
    },
    isFileExtensionValid() {
      return [
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'text/plain'
      ].includes(this.fileType);
    }
  },
  methods: {
    uploadWalletsEntriesFile(event) {
      const [file] = event.target.files;
      this.file = file;
      this.resultMessage = '';
    },
    async processPaymentFile() {
      this.isProcessing = true;
      if (!this.isFileExtensionValid) {
        this.isProcessing = false;
        this.alert({
          message: this.$t('transactions.uploadInstructions'),
          alertType: 'is-danger'
        });
        return;
      }
      let rows;
      try {
        const reader = new CreditToWalletReader(this.file);
        rows = await reader.rows();
      } catch (error) {
        this.isProcessing = false;
        this.alert({
          message: `${this.$t('transactions.processFileError')}. ${error.message}.`,
          alertType: 'is-danger'
        });
        return;
      }
      let response;
      try {
        let origin = '';
        let payment = {};
        const { increase } = this;

        if (this.file.name === 'seguros.xlsx') {
          origin = 'DEFAULT_INSURANCE';
          payment = rows.map(client => {
            return {
              idNumber: client.Rut,
              amount: client.Monto,
              description: `Abono por concepto de Seguro de Cesantía Sura (${client.Fecha}), siniestro n° ${client.Siniestro}. Cliente: ${client.Nombre}`
            };
          });
        }
        if (this.file.name === 'minvu.xlsx') {
          const paymentMonth = new Date().toLocaleString('default', { month: 'long' });
          const paymentYear = new Date().getFullYear();
          origin = 'MINVU';
          payment = rows.map(client => {
            return {
              companyOperationId: client.companyOperationId,
              amount: client.Monto,
              description: `Abono por concepto de beneficio MINVU ${paymentMonth} ${paymentYear} por ${client.Uf} UF`
            };
          });
        }
        if (this.file.name === 'inmobiliarias.xlsx') {
          origin = 'REAL_ESTATE';
          payment = rows.map(client => {
            return {
              idNumber: client.Rut,
              amount: client.Monto,
              description: `Abono por concepto de pago de cuota n° ${client.Cuota} por inmobiliaria ${client.Inmobiliaria}. Cliente: ${client.Nombre}`
            };
          });
        }

        response = await createWalletEntryForDifferentPaymentSources(origin, increase, payment);
      } catch (_error) {
        this.isProcessing = false;
        this.alert({ message: 'Ocurrió un error al conectarnos con el servidor' });
        return;
      }
      if (response.length === 0) {
        // Revisar acá
        this.alert({ message: 'Los datos se han procesado correctamente', alertType: 'is-success' });
        this.resultMessage = 'Los datos se han procesado correctamente';
      } else {
        this.$buefy.dialog.alert({
          html: true,
          title: 'Atención!',
          message: `Los datos no fueron procesados. Existen problemas con los siguientes registros: <br><br> ${response}.`,
          hasIcon: true,
          type: 'is-danger',
          confirmText: 'Entendido. Tomo nota!'
        });
        this.resultMessage = 'Los datos no pudieron ser procesados';
      }
      this.isProcessing = false;
    }
  }
};
</script>

<style scoped>
.min-height-100 {
  min-height: 100px !important;
}
</style>
